import { pdf } from "@react-pdf/renderer";
import moment from "moment";
import React from "react";
import { endpoint } from "views/pages/manage/common/constant";
import {
  documentServiceBaseUrl,
  putpost,
  uploadpost,
} from "../../../../../../services/http";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
  getCookie,
} from "../../../common/utils/methods/commonMethods/utilityMethod";
import {
  failureToast,
  successToast,
} from "../../../common/utils/methods/toasterFunctions/function";
import {
  formatPaidItemType,
  getPaidItemListApi,
  updateUrlForCentralizedAdm,
} from "./concessionDetails/common";
import { CMPR_FLAG_VALUES } from "./concessionDetails/ApplyCmprDialog";
// import CSummary from './templates/CourseSummary';
// import DraftSummary from './templates/draftSummary';
// import FeeDetails from './templates/FeeDetails';
// import PSummary from './templates/Psummary';

// import MyDocument from './templates/wrapper';

export const isRefreshPage = (response) => {
  if (response && response?.code === 412) {
    failureToast(response?.message);
    setTimeout(() => window.location.reload(false), 3000);
    return;
  }
};

export const getBusinessAreaQR = async (id) => {
  return new Promise(async (resolve) => {
    try {
      const data = await fetchAllPostPromisedData(
        `${endpoint.qrCode.searchQr}?offset=0`,
        { businessAreaId: [id] }
      );

      const activeQr = data?.data?.qrCodeResponseDtoList?.filter(
        (i) => i.status === "ACTIVE"
      );

      if (activeQr?.[0]?.qrCode) {
        const downloadUrlData = await fetchAllPostPromisedData(
          `${endpoint.fetchS3Url.getDownloadUrl}?key=${data?.data?.qrCodeResponseDtoList?.[0]?.qrCode}`,
          {}
        );
        resolve(downloadUrlData?.data?.url ?? "");
      } else {
        resolve("");
      }
    } catch (error) {
      console.error(error);
      resolve("");
    }
  });
};
// businessArea/getBusinessAreaContactDetailsLocation

export const getBusinessAreaAddress = async (id) => {
  return new Promise(async (resolve) => {
    try {
      const data = await fetchAllPromisedData(
        `${endpoint.businessArea.getBusinessAreaContactDetailsLocation}/${id}`
      );
      const address = data?.locationDetailsDto
        ? `${data?.locationDetailsDto?.buildingName}, ${data?.locationDetailsDto?.address1} ${data?.locationDetailsDto?.address2} ${data?.locationDetailsDto?.city}, ${data?.locationDetailsDto?.district} (${data?.locationDetailsDto?.pincode}),  ${data?.locationDetailsDto?.state}, ${data?.locationDetailsDto?.country} `
        : "";
      resolve(address);
    } catch (error) {
      console.error(error);
      resolve("");
    }
  });
};

export const getStudentAddress = async (id) => {
  return new Promise(async (resolve) => {
    try {
      const data = await fetchAllPromisedData(
        `${endpoint.studentDetails.getStudentContactDetails}/${id}`
      );
      const activeAddress = data?.studentAddressDetailDTOList
        ? data?.studentAddressDetailDTOList?.find(
            (i) => i.status === "ACTIVE"
          ) ?? null
        : null;
      const address = activeAddress
        ? `${activeAddress.addressLine1}, ${activeAddress.addressLine2} ${activeAddress.city} ${activeAddress.state}, ${activeAddress.country} (${activeAddress.postalCode})`
        : "";
      const activePhone = data?.studentPhoneDetailDTOList
        ? data?.studentPhoneDetailDTOList?.find(
            (i) => i.isPreferred === false
          ) ?? null
        : null;
      const phone = activePhone ? activePhone?.contactValue : "";
      resolve({ address, phone });
    } catch (error) {
      console.error(error);
      resolve({ address: "", phone: "" });
    }
  });
};

export const getVanDetails = async (psid, applicationId) => {
  try {
    const resp = await fetchAllPromisedData(
      `${endpoint.getVanDetailsApplicationIdAndPsid}/${applicationId}/${psid}`
    );
    return resp?.length ? resp[0] : { van: "", ifscCode: "" };
  } catch (err) {
    console.error(err);
  }
};

const checkAndCreateDepositSlip = async (
  name,
  file,
  status,
  key,
  applicationQuotationId,
  scb,
  fcb,
  feeBreakup,
  otherChargesMessage,
  sendEmailNotification,
  getEligibleComponentList,
  getFileUploadUrls,
  templateName
) => {
  if (status === "APPL") {
    const { depositeData: eligibleComponents, dateAndItemMapping } =
      await getEligibleComponentList(applicationQuotationId);

    if (eligibleComponents?.length) {
      const qrCode = await getBusinessAreaQR(
        eligibleComponents?.[0]?.businessAreasId
      );
      const fileNameArr = eligibleComponents.map(
        (i) => i.name.split(" ").join("_") + ".pdf"
      );
      await getFileUploadUrls(
        fileNameArr,
        eligibleComponents,
        dateAndItemMapping,
        qrCode,
        false,
        applicationQuotationId,
        true
      )
        .then((d) => {
          const refArr = d?.itemAndS3KeyDtoList
            ? [...d?.itemAndS3KeyDtoList]
            : [];
          const installment = { ...file.installments };

          refArr.forEach((item1) => {
            const { itemType = "", depositSlipReferenceNumber = "" } =
              item1 || {};
            for (const key in installment)
              installment[key].forEach((item2, index) => {
                if (item2.itemType === itemType)
                  installment[key][index].slipReference =
                    depositSlipReferenceNumber;
              });
          });
          getFilePath(
            name,
            { ...file, installment: installment },
            status,
            key,
            applicationQuotationId,
            scb,
            fcb,
            feeBreakup,
            otherChargesMessage,
            sendEmailNotification,
            getEligibleComponentList,
            getFileUploadUrls,
            templateName
          );
        })
        .catch((e) => {
          console.log(e);
          getFilePath(
            name,
            file,
            status,
            key,
            applicationQuotationId,
            scb,
            fcb,
            feeBreakup,
            otherChargesMessage,
            sendEmailNotification,
            getEligibleComponentList,
            getFileUploadUrls,
            templateName
          );
        });
    } else {
      getFilePath(
        name,
        file,
        status,
        key,
        applicationQuotationId,
        scb,
        fcb,
        feeBreakup,
        otherChargesMessage,
        sendEmailNotification,
        getEligibleComponentList,
        getFileUploadUrls,
        templateName
      );
    }
  }
};

const getFilePath = (
  name,
  file,
  status,
  key,
  applicationQuotationId,
  scb,
  fcb,
  feeBreakup,
  otherChargesMessage,
  sendEmailNotification,
  getEligibleComponentList,
  getFileUploadUrls,
  templateName
) => {
  const formData = {
    bulk: false,
    fileName: name,
    docType: "pdf",
    sourceId: 1,
    keyValue: new Date(),
    serviceName: "ENROLLMENT_CONCESSION_UPLOAD",
  };

  putpost(
    `${documentServiceBaseUrl}/documentManagement/getUploadUrl`,
    (data) => {
      if (data.code === 200 && data.data) {
        return saveDataToStorage(
          data.data,
          file,
          name,
          status,
          key,
          applicationQuotationId,
          scb,
          fcb,
          feeBreakup,
          otherChargesMessage,
          sendEmailNotification,
          getEligibleComponentList,
          getFileUploadUrls,
          templateName
        );
      }
      // submitOnAws()
      return null;
    },
    (data) => {
      failureToast(data["message"]);
      return null;
    },
    formData,
    "post"
  );
};

const saveDataToStorage = async (
  res,
  file,
  name,
  status,
  key,
  applicationQuotationId,
  scb,
  fcb,
  feeBreakup,
  otherChargesMessage,
  sendEmailNotification,
  getEligibleComponentList,
  getFileUploadUrls,
  templateName
) => {
  // const formData = new FormData();
  // formData.append("File", file);
  // formData.append("destinationfolder", res.bucket);
  const formData = {
    templateName: templateName,
    templateData: { ...file, name: name?.split(".")?.[0] },
    uploadUrl: res.storage,
  };

  await fetchAllPostPromisedData(endpoint.createPdf, formData);
  updateStatus(
    res.key,
    status,
    key,
    applicationQuotationId,
    scb,
    fcb,
    feeBreakup,
    otherChargesMessage,
    sendEmailNotification
  );
};

const updateStatus = async (
  s3key,
  status,
  key,
  applicationQuotationId,
  scb,
  fcb,
  feeBreakup,
  otherChargesMessage,
  sendEmailNotification
) => {
  let request = {
    applicationQuotationId: applicationQuotationId,
    chargeStatus: status,
    draftSummaryKey: null,
    provisionalSummaryKey: null,
    courseFeeSummaryKey: null,
    sendEmailNotification: sendEmailNotification || false,
  };
  request = { ...request, [key]: s3key };
  const response = await fetchAllPostPromisedData(
    `${endpoint.updateStudentChargeSummary}`,
    request,
    "put"
  );
  if (response?.code === 200) {
    successToast(response?.message);
    if (scb) {
      scb({ otherChargesMessage: otherChargesMessage });
      fcb();
    }
  } else {
    if (fcb) {
      fcb();
    }
    // failureToast(response?.message ?? 'Not able to process request , please try after sometime.')
  }
};

const getPaidItemList = async (
  applicationId,
  applicationQuotationDetailsId
) => {
  
  const response = await getPaidItemListApi({
    applicationId,
    applicationQuotationDetailsId,
  });
  return formatPaidItemType(response);
};

const validateBreakupItemMapping = (
  paymentList = [],
  breakupList = [],
  appliedCmplrFlagValue
) => {
  if (!paymentList?.length) return true;
  if (
    (!appliedCmplrFlagValue ||
      appliedCmplrFlagValue === CMPR_FLAG_VALUES.BYPASS_CMPR) &&
    paymentList.length
  ) {
    // check paid item should not be into this list
    // if paid and still going then break the
    const exists = paymentList.some((paidItem) =>
      breakupList.studentChargesFeeBreakup.some(
        (feeItem) => feeItem.itemType === paidItem.itemType
      )
    );
    if (exists) return false;
  }

  return true;
};

export const isInValidConcessionMapping = (request )=>{
  return  request.studentChargesFeeBreakupRequestDto?.studentChargesFeeBreakup.some(item=>item.concessionApplied>0 && item.concessionIds?.length === 0)
}

export const updateQuestionStatus = async (
  concessionModificationAllowed,
  forCentralizedAdmission,
  status,
  draftSummaryObject,
  courseSummaryObject,
  provisionalObject,
  feeBreakup,
  captureRef,
  applicationQuotationId,
  scb,
  fcb,
  courseData,
  sendEmailNotification,
  getEligibleComponentList,
  getFileUploadUrls,
  stateId
) => {
  try {
    
    const request = {
      chargeStatus: status,
      studentChargesFeeBreakupRequestDto: feeBreakup,
      concessionModificationAllowed,
    };


    const paymentList = await getPaidItemList(
      draftSummaryObject?.applicationNumber ||feeBreakup?.applicationId ,
      applicationQuotationId,
    );

    const isValidRequest = validateBreakupItemMapping(paymentList, feeBreakup,feeBreakup?.appliedCmplrFlagValue);
    if (!isValidRequest) {
      failureToast(
        "We're updating the payment information. Please hold on while we refresh the page."
      );
      setTimeout(() => window.location.reload(false), 3000);
      return ; 
    }

    const isInValidConcession = isInValidConcessionMapping(request)
    if (isInValidConcession) {
      failureToast(
        "Concession mapping is not correct. Please hold on while we refresh the page."
      );
      setTimeout(() => window.location.reload(false), 3000);
      return ; 
    }



    if (status == "VERY") {
      try {
        let url = `${
          endpoint.updateStudentQuotationStatus
        }?applicationQuotationId=${+applicationQuotationId}`;

        if (forCentralizedAdmission) {
          url = updateUrlForCentralizedAdm(url);
        }

        const response = await fetchAllPostPromisedData(
          url,
          request,
          "post",
          true,
          { state: feeBreakup?.state }
        );
        isRefreshPage(response);
        const qrCode = await getBusinessAreaQR(draftSummaryObject?.buId);
        const buAddress = await getBusinessAreaAddress(
          draftSummaryObject?.buId
        );
        const studentAddress = await getStudentAddress(
          draftSummaryObject?.studentId
        );
        const { van, ifscCode } = await getVanDetails(
          draftSummaryObject?.studentId,
          draftSummaryObject?.applicationNumber
        );

        if (response?.code === 200) {
          getFilePath(
            "darftSummary.pdf",
            {
              ...draftSummaryObject,
              qrCode: qrCode,
              buAddress: buAddress,
              studentAddress: studentAddress?.address,
              vanDetails: van,
              ifscCode: ifscCode,
            },
            status,
            "draftSummaryKey",
            response?.data?.applicationQuotationId,
            scb,
            fcb,
            feeBreakup,
            sendEmailNotification,
            null,
            null,
            null,
            "draftSummary"
          );
        } else {
          fcb();
        }
      } catch (e) {
        fcb();
        console.log(e);
      }
    } else if (status == "APPL") {
      try {
        let url = `${
          endpoint.updateStudentQuotationStatus
        }?applicationQuotationId=${+applicationQuotationId}`;

        if (forCentralizedAdmission) {
          url = updateUrlForCentralizedAdm(url);
        }

        const response = await fetchAllPostPromisedData(
          url,
          request,
          "post",
          true,
          { state: feeBreakup?.state }
        );
        isRefreshPage(response);

        // const res = await fetchAllPromisedData(
        //   endpoint.course_details.courseAttribute
        // );
        // const qrCode = await getBusinessAreaQR(courseSummaryObject?.buId);
        // const buAddress = await getBusinessAreaAddress(
        //   courseSummaryObject?.buId
        // );
        // const studentAddress = await getStudentAddress(
        //   courseSummaryObject?.studentId
        // );
        // const { van, ifscCode } = await getVanDetails(
        //   courseSummaryObject?.studentId,
        //   courseSummaryObject?.applicationNumber
        // );

        if (response?.code === 200) {
          if (response?.data?.loanChargesMessage) {
            successToast(response?.data?.loanChargesMessage);
          }
          successToast(response?.message);
          scb && scb();
          fcb && fcb();
          if (response?.data?.isVanCreated) {
            successToast(
              "The VAN account number has been successfully created and an email notification is successfully sent for the same."
            );
          }
          //   let courseName = "";
          //   if (response?.data?.otherChargesDetailsDTOS?.[0]?.courseId) {
          //     courseName = await fetchAllPromisedData(
          //       `${endpoint.course_details.getByCourseId}/${response?.data?.otherChargesDetailsDTOS?.[0].courseId}`
          //     );
          //   }
          //   const securityObject = response.data?.otherChargesDetailsDTOS.map(
          //     (i) => {
          //       return {
          //         courseName: courseName?.[0]?.courseName ?? "",
          //         courseId: i.courseId,
          //         installmentObj: {
          //           installmentName:
          //             Array.isArray(res) &&
          //             res?.find((item) => item.id === i.chargeTypeId)
          //               ?.courseAttributeValueDispValue,
          //           dueDate: moment().format("DD-MMM-YYYY"),
          //           slipReference: i?.id,
          //           mrp: i.basePrice?.toFixed(2),
          //           // concessionPer: '0.00',
          //           // lumpSumPercent: '0.00',
          //           concessionAmount:
          //             i.approvalStatus === "APPROVED" && i.waveOffAmount
          //               ? i.waveOffAmount
          //               : "0.00",
          //           totalTax: i.taxes,
          //           netPayable:
          //             i.approvalStatus === "APPROVED" && i.waveOffAmount
          //               ? i.finalPayable
          //               : i.netPayableAmount,
          //           // paidAmount: '0.00'
          //         },
          //       };
          //     }
          //   );

          //   const newInstallments = { ...courseSummaryObject?.installments };
          //   // newInstallments[Object.keys(newInstallments)?.[0]] = [...securityInstallments, ...newInstallments[Object.keys(newInstallments)?.[0]]]
          //   let total = 0;
          //   response.data.otherChargesDetailsDTOS.map((i) => {
          //     total =
          //       Number(total) +
          //       Number(
          //         i.approvalStatus === "APPROVED" && i.waveOffAmount
          //           ? i.finalPayable
          //           : i.netPayableAmount
          //       );
          //   });

          //   const newTotal = { ...courseSummaryObject?.installmentsTotals };

          //   newTotal[Object.keys(newInstallments)?.[0]] = {
          //     ...newTotal[Object.keys(newInstallments)?.[0]],
          //     totalMrpIncTax:
          //       newTotal[Object.keys(newInstallments)?.[0]]?.totalMrpIncTax +
          //       total,
          //     totalNetpaybleIncTax:
          //       newTotal[Object.keys(newInstallments)?.[0]]
          //         ?.totalNetpaybleIncTax + total,
          //   };

          //   const newGrandTotal = { ...courseSummaryObject?.grandTotal };
          //   newGrandTotal["totalMrpIncTax"] =
          //     newGrandTotal["totalMrpIncTax"] + total;
          //   newGrandTotal["totalNetpaybleIncTax"] =
          //     newGrandTotal["totalNetpaybleIncTax"] + total;

          //   checkAndCreateDepositSlip(
          //     "courseSummary.pdf",
          //     {
          //       ...courseSummaryObject,
          //       studentAddress: studentAddress?.address,
          //       installments: newInstallments,
          //       installmentsTotals: newTotal,
          //       otherCharges: securityObject,
          //       grandTotal: newGrandTotal,
          //       qrCode: qrCode,
          //       buAddress: buAddress,
          //       vanDetails: van,
          //       ifscCode: ifscCode,
          //     },
          //     status,
          //     "courseFeeSummaryKey",
          //     response?.data?.applicationQuotationId,
          //     scb,
          //     fcb,
          //     feeBreakup,
          //     response.data?.otherChargesMessage,
          //     sendEmailNotification,
          //     getEligibleComponentList,
          //     getFileUploadUrls,
          //     "courseSummary"
          //   );

          // updateStatus(
          //   null,
          //   status,
          //   "courseFeeSummaryKey",
          //   response?.data?.applicationQuotationId,
          //   scb,
          //   fcb,
          //   null,
          //   response.data?.otherChargesMessage,
          //   sendEmailNotification
          // )
        }
      } catch (e) {
        console.log(e);
      }
    } else if (status == "PAPP") {
      try {
        let url = `${
          endpoint.updateStudentQuotationStatus
        }?applicationQuotationId=${+applicationQuotationId}`;

        if (forCentralizedAdmission) {
          url = updateUrlForCentralizedAdm(url);
        }

        const response = await fetchAllPostPromisedData(
          url,
          request,
          "post",
          true,
          { state: feeBreakup?.state }
        );
        isRefreshPage(response);

        // const res = await fetchAllPromisedData(endpoint.course_details.courseAttribute);
        // const qrCode = await getBusinessAreaQR(provisionalObject?.buId);
        // const buAddress = await getBusinessAreaAddress(provisionalObject?.buId);
        //const studentAddress = await getStudentAddress(provisionalObject?.studentId);
        // const {van, ifscCode} = await getVanDetails(provisionalObject?.studentId, provisionalObject?.applicationNumber);

        if (response?.code === 200) {
          successToast(response?.message);
          scb && scb();
          fcb && fcb();

          if (response?.data?.isVanCreated) {
            successToast(
              "The VAN account number has been successfully created and an email notification is successfully sent for the same."
            );
          }
          // let courseName = ''
          // if (response?.data?.otherChargesDetailsDTOS?.[0]?.courseId) {
          //     courseName = await fetchAllPromisedData(`${endpoint.course_details.getByCourseId}/${response?.data?.otherChargesDetailsDTOS?.[0].courseId}`);
          // }
          // const securityObject = response.data?.otherChargesDetailsDTOS.map(i => {
          //     return {
          //         courseName: courseName?.[0]?.courseName ?? '',
          //         courseId: i.courseId,
          //         installmentObj: {
          //             installmentName: Array.isArray(res) && res?.find(item => item.id === i.chargeTypeId)?.courseAttributeValueDispValue,
          //             dueDate: moment(new Date()).format('DD-MMM-YYYY'),
          //             slipReference: '',
          //             mrp: i.basePrice?.toFixed(2),
          //             concessionAmount: i.approvalStatus === 'APPROVED' && i.waveOffAmount ? i.waveOffAmount : '0.00',
          //             totalTax: i.taxes,
          //             netPayable: i.approvalStatus === 'APPROVED' && i.waveOffAmount ? i.finalPayable : i.netPayableAmount,
          //         },
          //     }
          // })

          // const newInstallments = { ...provisionalObject?.installments };
          // // newInstallments[Object.keys(newInstallments)?.[0]] = [...securityInstallments, ...newInstallments[Object.keys(newInstallments)?.[0]]]
          // let total = 0;
          // response.data.otherChargesDetailsDTOS.map(i => {
          //     total = Number(total) + Number(i.approvalStatus === 'APPROVED' && i.waveOffAmount ? i.finalPayable : i.netPayableAmount)
          // })

          // const newTotal = { ...provisionalObject?.installmentsTotals };
          // newTotal[Object.keys(newInstallments)?.[0]] = {
          //     ...newTotal[Object.keys(newInstallments)?.[0]],
          //     totalMrpIncTax: newTotal[Object.keys(newInstallments)?.[0]]?.totalMrpIncTax + total,
          //     totalNetpaybleIncTax: newTotal[Object.keys(newInstallments)?.[0]]?.totalNetpaybleIncTax + total
          // }

          // const newGrandTotal = { ...provisionalObject?.grandTotal };
          // newGrandTotal['totalMrpIncTax'] = newGrandTotal['totalMrpIncTax'] + total;
          // newGrandTotal['totalNetpaybleIncTax'] = newGrandTotal['totalNetpaybleIncTax'] + total;
          // getFilePath('provisionalSummary.pdf', { ...provisionalObject, studentAddress: studentAddress?.address, installments: newInstallments, installmentsTotals: newTotal, otherCharges: securityObject, grandTotal: newGrandTotal, qrCode: qrCode, buAddress: buAddress,vanDetails : van, ifscCode : ifscCode }, status, 'provisionalSummaryKey', response?.data?.applicationQuotationId, scb, fcb, feeBreakup, response.data?.otherChargesMessage, sendEmailNotification, getEligibleComponentList, getFileUploadUrls, 'provisionalSummary');
        }
      } catch (e) {
        console.log(e);
      }
    }
  } catch (error) {}
};

export const isPendingForApproval = (status) => {
  const isPending = [
    "L1_REJECT",
    "L2_REJECT",
    "L3_REJECT",
    "L1_APPROVED",
    "L2_APPROVED",
    "L3_APPROVED",
  ].includes(status)
    ? false
    : true;
  return isPending;
};
const orderMap = {
  first: 1,
  second: 2,
  third: 3,
  fourth: 4,
  fifth: 5,
};
export const getCurrentYearAndCoursePricingDetail = async (application) => {
  try {
    const { businessAreaId, courseId, termId } = application || {};
    const reqBody = {
      courseId,
      businessArea: businessAreaId,
      term: termId,
    };

    const res = await fetchAllPostPromisedData(
      endpoint?.course?.getCoursePricingDetails,
      reqBody
    );


    if (res?.data) {
      const data = res.data;
      const today = new Date();

      const yearKeys = Object.keys(data)
        .filter((key) => key.toLowerCase().includes("yearstartdate"))
        .sort((a, b) => {
          const aPrefix = a.split("YearStartDate")[0].toLowerCase(); // e.g., 'first'
          const bPrefix = b.split("YearStartDate")[0].toLowerCase(); // e.g., 'second'
          return orderMap[aPrefix] - orderMap[bPrefix];
        }); // Ensures firstYearStartDate, secondYearStartDate order
      for (let i = 0; i < yearKeys.length; i++) {
        const startKey = yearKeys[i];
        const endKey = startKey.replace("YearStartDate", "EndDate");
        const startDateStr = data[startKey];
        const endDateStr = data[endKey];

        if (startDateStr && endDateStr) {
          const startDate = new Date(startDateStr);
          const endDate = new Date(endDateStr);

          if (today >= startDate && today <= endDate) {
            return {...data, year: i + 1,}; // Year is 1-based
          }
        }
      }

      // Edge case: if today's date is before the earliest start date
      const earliestStartDateStr = data[yearKeys[0]];
      if (earliestStartDateStr && today < new Date(earliestStartDateStr)) {
        return {...data, year:1};
      }
    }

    return null;
  } catch (error) {
    console.error("Error in getCurrentYear:", error);
    return {year: null};
  }
};

const getCourseDetails = async (reqBody) => {
  return await fetchAllPostPromisedData(
    endpoint?.course?.getManualCourseDetailsByCourseId,
    reqBody
  );
};
export const getAppliedLoanAmount = async (application = {}) => {
  const { businessAreaId, courseId, termId } = application;
  if (!courseId) return false;

  const courseDetails = await getCourseDetails({
    courseId,
    businessAreaId,
    termId,
  });
  return courseDetails?.data ? courseDetails.data : null;
};

export const transformChargeStatus = (chargeStatus) => {
  if (chargeStatus === "MCONC") return "CONC";
  else if (chargeStatus === "MVERY") return "VERY";
  return chargeStatus;
};

export const LOAN_APPLICATION_ERROR_MGS =
  "Please ensure the concessions are approved before finalizing the charges. Provisional finalization is not available for loan-based applications.";

export const CMPLR_APPLICATION_ERROR_MGS =
  "Please ensure the concessions are approved before finalizing the charges. Provisional finalization is not available";
export const ERROR_MGS_FINALIZE =
  "No changes have been made to the Concession Percentage since the previous quotation. Please update the concession details before finalizing the charges";

  export const ERROR_MGS_VERIFY =
  "No changes have been made to the Concession Percentage since the previous quotation. Please update the concession details before verifying the charges";


export const GST_MISSING_DETAILS_ERROR_MGS =
  "GST information is incomplete, please check and update the mandatory information required on the GST form";

export const isCentralizedAdmissionCase = (opportunityOwnerId) =>
  getCookie("userId") === opportunityOwnerId;

export const getLumpsumCategoryData = (data) => {
  const filteredData = [];

  const currentData = JSON.parse(JSON.stringify(data));
  currentData.forEach((category) => {
    // if (
    //   category.categoryDispVal
    //     .toLowerCase()
    //     .includes(searchValue.toLowerCase())
    // ) {
    //   filteredData.push(category);
    //   return;
    // }

    const subcategories = [];

    category.subCategories.forEach((subcategory) => {
      if (subcategory.isLumpSum) {
        subcategories.push(subcategory);
        return;
      }

      const subsubcategories = [];

      subcategory.subSubCategory.forEach((subsubcategory) => {
        if (subsubcategory.isLumpSum) {
          subsubcategories.push(subsubcategory);
        }
      });

      if (subsubcategories.length > 0) {
        subcategory.subSubCategory = subsubcategories;
        subcategories.push(subcategory);
      }
    });

    if (subcategories.length > 0) {
      category.subCategories = subcategories;
      filteredData.push(category);
    }
  });

  return filteredData;
};
// filter payment mode and lumpsum categroy
export const getFilteredSubCategory = (list = []) => {
  const paymentCategory = list.filter(
    (item) => item.categoryDispVal?.toLowerCase() === "payment"
  );
  const lumpsumCategorys = getLumpsumCategoryData(list);
  return [...paymentCategory, ...lumpsumCategorys];
};

export const getLoanAlertMessage = (
  loanSchemeMasterId,
  allSchemes = [],
  loanCourseFeeDetails
) => {
  if (!loanSchemeMasterId || !loanCourseFeeDetails?.finalAmount) return false;

  const appliedMaster = allSchemes.find(
    (item) => item?.id === loanSchemeMasterId
  );
  if (!appliedMaster) return false;

  const { vendorName } = appliedMaster;
  const { finalAmount, courseDescription, courseId } = loanCourseFeeDetails;

  return `The student has opted for a ${vendorName}. As per the guidelines, an additional charge of ₹${finalAmount} will be automatically applied under Course ID ${courseId} (${courseDescription}).`;
};

export const isTransferredStudent = (studentStatus) => {
  return (
    studentStatus?.validationMessage
      ?.toLowerCase()
      .includes("the student is transferred") || false
  );
};
